export function getCookieValue(name) {
  const cookies = Object.fromEntries(
    document.cookie.split("; ").map((cookie) => cookie.split("="))
  );
  return cookies[name] || null;
};

export function isWebView() {
  return getCookieValue('primary_source') === 'fusion_webview';
}

export function isObject(data) {
  let isValid = false;
  if (isDataValid(data)) {
    if (typeof data === "object") {
      isValid = true;
    }
  }
  return isValid;
}

export function isDataValid(data) {
  let isValid = false;
  if (data !== null && data !== undefined) isValid = true;
  return isValid;
}

export const passMessageToNative = (message, content = null) => {
  if (true) {
    let contentStr = isObject(content) ? JSON.stringify(content) : content;
    const JS_BRIDGE = global?.JSBridge;
    if (JS_BRIDGE?.fireJavaScriptEvent) {
      JS_BRIDGE.fireJavaScriptEvent(message, contentStr);
    }
  }
};
